import { format } from 'date-fns';

const formatDate = (dt: string) => format(new Date(dt), 'MMM d, yyyy');

export default formatDate;
